import { render, staticRenderFns } from "./managementTeam.vue?vue&type=template&id=61277fac&scoped=true&"
import script from "./managementTeam.vue?vue&type=script&lang=js&"
export * from "./managementTeam.vue?vue&type=script&lang=js&"
import style0 from "./managementTeam.vue?vue&type=style&index=0&id=61277fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61277fac",
  null
  
)

export default component.exports